// 获取付款记录
import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IInput {
    status: number;
    page: number;
    size: number;
}

// tslint:disable-next-line:max-line-length
export const getPaymentHistoryList = (data: IInput): Promise<IListResponse<IPaymentRecord>> => {
    return fetchData(Api.GET_PAYMENT_HISTORY_LIST, data).then((res: IListResponse<IPaymentRecord>) => {
        return res;
    });
};

export const getPaymentHistoryListSync = fetchDataSync(getPaymentHistoryList);
